import { useState, useCallback } from 'react';

export const useFormData = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNumber: '',
    agreeToTerms: false,
  });

  const updateFormData = useCallback((updates) => {
    setFormData((prev) => ({
      ...prev,
      ...updates,
    }));
  }, []);

  return { formData, updateFormData };
};
